/* Do not modify the automatically generated code */
import Alpha from "@/components/alpha";
import Checkboard from "@/components/checkboard";
import Chrome from "@/components/chrome";
import Compact from "@/components/compact";
import EditableInput from "@/components/editable-input";
import Grayscale from "@/components/grayscale";
import Hue from "@/components/hue";
import Material from "@/components/material";
import Photoshop from "@/components/photoshop";
import Saturation from "@/components/saturation";
import Sketch from "@/components/sketch";
import Slider from "@/components/slider";
import Swatches from "@/components/swatches";
import Twitter from "@/components/twitter";
import ColorPicker from "@/components/color-picker";

const components = [
  Alpha,
  Checkboard,
  Chrome,
  Compact,
  EditableInput,
  Grayscale,
  Hue,
  Material,
  Photoshop,
  Saturation,
  Sketch,
  Slider,
  Swatches,
  Twitter,
  ColorPicker,
];

export {
  components,
  Alpha,
  Checkboard,
  Chrome,
  Compact,
  EditableInput,
  Grayscale,
  Hue,
  Material,
  Photoshop,
  Saturation,
  Sketch,
  Slider,
  Swatches,
  Twitter,
  ColorPicker,
};
